import { useDomainCRUDActions } from '@mm/state/actions/DomainCRUDActions';
import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import { domainSelector } from '@mm/state/selectors/domainSelector';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@mm/components';
import { Result } from '../ChatWidgetTroubleshootingToolResult';

type Props = {
  runDiagnostic: () => Promise<void>;
  isXRay?: boolean;
};
export const useDomainWhitelistedResult = (props: Props): Result => {
  const { runDiagnostic, isXRay } = props;
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  const domain = useSelector(domainSelector);
  const { chatWidgetChannel } = useSelector(activeChatbotSelector);

  const { update: updateDomains } = useDomainCRUDActions();

  const [whitelisting, setWhitelisting] = useState(false);
  if (!result || isXRay) {
    return;
  }

  if (chatWidgetChannel !== 'facebook' && chatWidgetChannel !== 'omnichat') {
    return;
  }
  if (result.localTests.domainWhitelisted) {
    return {
      result: 'ok',
      description: 'Website domain is whitelisted',
    };
  }
  const parsedUrl = new URL(result.url);

  const whitelistDomain = async () => {
    setWhitelisting(true);
    const { id, connectedPageId, domainsList } = domain;
    await updateDomains({
      id,
      connectedPageId,
      domainsList: [...(domainsList || []), parsedUrl.origin],
    });
    await runDiagnostic();
    setWhitelisting(false);
  };

  return {
    result: 'error',
    description: (
      <>
        Website domain <code>{parsedUrl.origin}</code> is not on the Whitelist
        <Button onClick={whitelistDomain} disabled={whitelisting}>
          Whitelist Domain
        </Button>
      </>
    ),
  };
};
